'use client';
import React from 'react';
import ParallaxText from '@components/ParallaxText';
import { Box, Stack } from '@mui/material';
import ReactHtmlParser from '@libs/reactHtmlParser';
import HouseLogo from '../HouseLogo';
import ParallaxBlock from '@components/ParallaxBlock';
import cn from './style.module.scss';
export default function HouseFooter(props: any) {
  const { t } = props;

  return (
    <Stack component="footer" className={cn.beachHouseFooter}>
      <Box className={cn.houseFooterInner}>
        <Box className={cn.houseFooterLogo}>
          <ParallaxBlock animationType="zoomIn" animationDuration={500}>
            <HouseLogo logoImage={props.logoImage} />
          </ParallaxBlock>
        </Box>
        <Box className={cn.houseFooterText}>
          <ParallaxText
            variant="p"
            animationType="slideInBottom"
            animationDuration={500}
          >
            {ReactHtmlParser(t['islandFooterContent'])}
          </ParallaxText>
        </Box>
      </Box>
    </Stack>
  );
}
